import React, { useState, useEffect } from "react";
import Footer from "../../Footer";
import "./pageStyles.css";
import { api_v2 } from "../../NewIndex.api";
import connect from "react-redux/es/connect/connect";

const WidgetImage = ({ imageId, alt }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!imageId) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    api_v2.fetchAndSetImage(
      imageId,
      (blob) => {
        if (!cancelled) setUrl(window.URL.createObjectURL(blob));
      },
      (e) => {
        console.warn(e.message);
      }
    );
    return () => {
      cancelled = true;
    };
  }, [imageId]);

  if (!url) return null;
  return <img src={url} alt={alt || ""} />;
};

const StaticPage = (props) => {
  const [template, setTemplate] = useState([]);
  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const id = searchParams.get("name");
    const payload = {
      templateName: id,
    };
    if (id) {
      api_v2.fetchContentLive(payload, (res) => {
        setTemplate(res.template);
      });
    }
  }, [props.location.search]);
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="container">
          <div className="content-container">
            {template.map((row, rowIndex) => (
              <div
                className={`rows ${row.columnType
                  .replace(" ", "")
                  .toLowerCase()}`}
                key={rowIndex}
              >
                {row.columns.map((entry, entryIndex) => {
                  // Widget Type 1: Banner image, title overlay, content below
                  if (entry.widgetType === "Widget Type 1") {
                    return (
                      <div
                        className={`content-column column-${entryIndex + 1}`}
                        key={entryIndex}
                      >
                        <div className="widget-1">
                          <div className="widget1-image-wrapper">
                            <WidgetImage
                              imageId={entry.widgetRequirement.image}
                              alt={entry.widgetRequirement.imageTitle}
                            />
                            <div className="widget1-image-overlay">
                              {entry.widgetRequirement.imageTitle}
                            </div>
                          </div>
                          <div
                            className="widget-content"
                            dangerouslySetInnerHTML={{
                              __html: entry.widgetRequirement.htmlContent,
                            }}
                          />
                        </div>
                      </div>
                    );
                  }
                  // Widget Type 2: Content left, image right
                  if (entry.widgetType === "Widget Type 2") {
                    return (
                      <div
                        className={`content-column column-${entryIndex + 1}`}
                        key={entryIndex}
                      >
                        <div className="entry widget-2">
                          <div
                            className="widget-content"
                            dangerouslySetInnerHTML={{
                              __html: entry.widgetRequirement.htmlContent,
                            }}
                          />
                          <div className="widget2-img-wrapper">
                            <WidgetImage
                              imageId={entry.widgetRequirement.image}
                              alt={entry.widgetRequirement.imageTitle}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  }
                  // Widget Type 3: Image left, content right
                  if (entry.widgetType === "Widget Type 3") {
                    return (
                      <div
                        className={`content-column column-${entryIndex + 1}`}
                        key={entryIndex}
                      >
                        <div className="entry widget-3">
                          <div className="widget3-img-wrapper">
                            <WidgetImage
                              imageId={entry.widgetRequirement.image}
                              alt={entry.widgetRequirement.imageTitle}
                            />
                          </div>
                          <div
                            className="widget-content"
                            dangerouslySetInnerHTML={{
                              __html: entry.widgetRequirement.htmlContent,
                            }}
                          />
                        </div>
                      </div>
                    );
                  }
                  // Widget Type 4: Content only
                  if (entry.widgetType === "Widget Type 4") {
                    return (
                      <div
                        className={`content-column column-${entryIndex + 1}`}
                        key={entryIndex}
                      >
                        <div className="entry widget-4">
                          <div
                            className="widget-content"
                            dangerouslySetInnerHTML={{
                              __html: entry.widgetRequirement.htmlContent,
                            }}
                          />
                        </div>
                      </div>
                    );
                  }
                  //fallback case
                  if (
                    !entry.widgetType ||
                    Object.keys(entry.widgetRequirement).length === 0
                  ) {
                    return (
                      <div
                        className={`content-column column-${entryIndex + 1}`}
                        key={entryIndex}
                      ></div>
                    );
                  }
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer submitInquiry={false} showHomeFooter={false} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps)(StaticPage);



// WEBPACK FOOTER //
// ./src/mi-app/Pages/Static Page/StaticPage.js